//
//
//
//
//
//
//
//
//
//

import Heading from '@/components/Heading'

export default {
  components: {
    Heading
  },

  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    }
  },

  computed: {
    id() {
      return this.$route.params.id // Current site id
    }
  }
}
